import React from 'react';
import Svg, { Path } from 'react-native-svg';

const CalendarIcon: React.FC<{ width?: number; height?: number }> = ({
  width = 14,
  height = 16,
}) => (
  <Svg
    width={width}
    height={height}
    viewBox="0 0 14 16"
    fill="none"
    preserveAspectRatio="xMidYMid meet"
  >
    <Path
      d="M12.3333 2.00002H11.6666V0.666687H10.3333V2.00002H3.66665V0.666687H2.33331V2.00002H1.66665C0.933313 2.00002 0.333313 2.60002 0.333313 3.33335V14C0.333313 14.7334 0.933313 15.3334 1.66665 15.3334H12.3333C13.0666 15.3334 13.6666 14.7334 13.6666 14V3.33335C13.6666 2.60002 13.0666 2.00002 12.3333 2.00002ZM12.3333 14H1.66665V6.66669H12.3333V14ZM12.3333 5.33335H1.66665V3.33335H12.3333V5.33335Z"
      fill="#005CBC"
    />
  </Svg>
);

export default CalendarIcon;
